import {
    SUMMARY_ALL,
    SuMMARY_DEFAULT,
    SUMMARY_OTHERS,
    SUMMARY_PROJECTS,
    SUMMARY_SELF_INTRODUCTION
} from "../../actions/path";

const initialState = {
    currentPath: '/',
    exPath: '/',
}

export const pathReducers = (state = initialState, action) => {
    if (action?.type === SuMMARY_DEFAULT) {
        return  {
            currentPath: SuMMARY_DEFAULT,
            exPath: state.currentPath,
        }
    }
    if (action?.type === SUMMARY_SELF_INTRODUCTION) {
        return  {
            currentPath: SUMMARY_SELF_INTRODUCTION,
            exPath: state.currentPath,
        }
    }
    if (action?.type === SUMMARY_PROJECTS) {
        return {
            currentPath: SUMMARY_PROJECTS,
            exPath: state.currentPath,
        }
    }
    if (action?.type === SUMMARY_OTHERS) {
        return {
            currentPath: SUMMARY_OTHERS,
            exPath: state.currentPath,
        }
    }
    if (action?.type === SUMMARY_ALL) {
        return {
            currentPath: SUMMARY_ALL,
            exPath: state.currentPath,
        }
    }

    return {
        currentPath: '/',
        exPath: state.currentPath,
    }
}